//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

export default Object.freeze({
    carParkingSpace:        'CAR_PARKING_SPACE_VALUE',
    inventoryValue:         'INVENTORY_VALUE',
    renovationCosts:        'RENOVATION_COSTS',
    acquisitionValue:       'ACQUISITION_VALUE',
    specialDeprecationEH40: 'SPECIAL_AFA_EH40_QNG',
});
